import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import rice from "../../../Assets/Projects/ML/Padi.png";
import rice2 from "../../../Assets/Projects/ML/Padi2.png";
import rice3 from "../../../Assets/Projects/ML/Padi3.png";
import rice4 from "../../../Assets/Projects/ML/Padi4.png";
import rice5 from "../../../Assets/Projects/ML/Padi5.png";
import rice6 from "../../../Assets/Projects/ML/Padi6.png";
import rice7 from "../../../Assets/Projects/ML/Padi7.png";


function RiceProductionPriority() {
  return (
    <ProjectDetailCard
      title="Rice Production Priority Classification System"
      image={rice}
      screenshots={[rice2, rice3, rice4]}
      description="
      Rice Production Priority Classification System is a web-based Machine Learning application developed to assist decision-making in determining rice production priorities across different regions. The system utilizes the Random Forest classification algorithm to analyze agricultural data, including cultivated area, planting targets, harvest targets, production targets, and productivity levels. In addition to generating accurate classifications, the application provides model evaluation, transparent prediction results, dataset management, and interactive visualizations, enabling users to better understand classification outcomes and support data-driven agricultural planning.
      "
      technologies={[
        "Python",
        "Scikit-learn",
        "Random Forest",
        "Pandas",
        "NumPy",
        "MySQL",
        "JavaScript",
        "Bootstrap 5",
        "HTML5",
        "CSS3",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={rice5} alt="gallery1" />
          <img src={rice6} alt="gallery2" />
          <img src={rice7} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default RiceProductionPriority;
